import { Component, inject } from "@angular/core";
import {
  FormControl,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { DialogHeaderComponent } from "../../../../shared/components/dialog-header/dialog-header.component";

const MIN_REASON_LENGTH = 15;
const MAX_REASON_LENGTH = 1000;
const reasonLength = (value: string) => Array.from(value.trim()).length;
const refundReasonLengthValidator: ValidatorFn = (control) => {
  const length = reasonLength(control.value ?? "");
  return length >= MIN_REASON_LENGTH && length <= MAX_REASON_LENGTH
    ? null
    : { reasonLength: true };
};

@Component({
  selector: "app-refund-request-modal",
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    ButtonComponent,
    DialogHeaderComponent,
  ],
  templateUrl: "./refund-request-modal.component.html",
  styleUrl: "./refund-request-modal.component.scss",
})
export class RefundRequestModalComponent {
  readonly minReasonLength = MIN_REASON_LENGTH;
  readonly maxReasonLength = MAX_REASON_LENGTH;
  readonly dialogRef = inject(
    MatDialogRef<RefundRequestModalComponent, string>,
  );
  readonly reason = new FormControl("", {
    nonNullable: true,
    validators: [Validators.required, refundReasonLengthValidator],
  });

  get reasonLength() {
    return reasonLength(this.reason.value);
  }

  submit() {
    if (this.reason.invalid) {
      this.reason.markAsTouched();
      return;
    }
    this.dialogRef.close(this.reason.value.trim());
  }
}
